/**
 * Widget font catalog: each `WebChatFont` slug to a CSS `font-family` stack.
 * The leading family must match the `@font-face` rules in fonts.css.
 */

const SANS_FALLBACK =
  'ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif';
const SERIF_FALLBACK = 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif';
const MONO_FALLBACK =
  'ui-monospace, SFMono-Regular, "SF Mono", Menlo, Consolas, "Liberation Mono", monospace';

// Variable-font families carry a " Variable" suffix in their @font-face
// declaration (Fontsource convention); the static fallback name is listed
// next so the stack still resolves if only the static face is present.
export const FONT_STACKS: Record<string, string> = {
  outfit: `"Outfit Variable", "Outfit", ${SANS_FALLBACK}`,
  inter: `"Inter Variable", "Inter", ${SANS_FALLBACK}`,
  roboto: `"Roboto Variable", "Roboto", ${SANS_FALLBACK}`,
  open_sans: `"Open Sans Variable", "Open Sans", ${SANS_FALLBACK}`,
  lato: `"Lato", ${SANS_FALLBACK}`,
  montserrat: `"Montserrat Variable", "Montserrat", ${SANS_FALLBACK}`,
  poppins: `"Poppins", ${SANS_FALLBACK}`,
  nunito: `"Nunito Variable", "Nunito", ${SANS_FALLBACK}`,
  work_sans: `"Work Sans Variable", "Work Sans", ${SANS_FALLBACK}`,
  lexend: `"Lexend Variable", "Lexend", ${SANS_FALLBACK}`,
  merriweather: `"Merriweather Variable", "Merriweather", ${SERIF_FALLBACK}`,
  lora: `"Lora Variable", "Lora", ${SERIF_FALLBACK}`,
  jetbrains_mono: `"JetBrains Mono Variable", "JetBrains Mono", ${MONO_FALLBACK}`,
};

/** Resolve a font slug to its CSS `font-family` stack, or null when unknown. */
export function resolveFontStack(slug: string | null | undefined): string | null {
  if (!slug) return null;
  return FONT_STACKS[slug] ?? null;
}
